import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import classNames from 'classnames';
import { bem } from 'helpers/class-name';

import Message from 'components/Message';

import './ClassReservationsSummaryTable.scss';

const messages = defineMessages({
  allCPBookings: {
    id: 'yield-management.insights.class-reservations.revenue-summary-table.all-cp-bookings',
    defaultMessage: 'All CP Bookings',
  },
  totalSpots: {
    id: 'yield-management.insights.class-reservations.revenue-summary-table.total-spots',
    defaultMessage: '{classpassBooked, plural, one {# booking} other {# bookings}}',
  },
});
const { block, element } = bem('class-reservations-summary-table');

const ClassReservationsSummaryTable = ({ classpassBooked }) => (
  <table className={block()}>
    <thead>
      <tr>
        <Message
          as="th"
          className={classNames(element('header-cell'), 'text--left')}
          message={messages.allCPBookings}
        />
      </tr>
    </thead>
    <tbody>
      <tr>
        <Message as="td" message={messages.totalSpots} values={{ classpassBooked }} />
      </tr>
    </tbody>
  </table>
);

ClassReservationsSummaryTable.propTypes = {
  classpassBooked: PropTypes.number,
};

export default ClassReservationsSummaryTable;
